import { api, PostStudyLogPayload } from '@/api';
import { useStudyGuard } from '@/shared/guard';

export const useCreateStudyLog = () => {
  const { studyId } = useStudyGuard();

  const postStudyLogMutation = api.apps.studyLog.mutation.usePostStudyLog();

  const createStudyLog = (payload: Partial<PostStudyLogPayload>, onSuccess?: () => void) => {
    if (!payload.body) {
      return;
    }

    const { body } = payload;

    postStudyLogMutation.mutate({ payload: { body }, studyId }, { onSuccess });
  };

  return { createStudyLog, isCreatingStudyLog: postStudyLogMutation.isPending };
};
